import { _breakP } from './utils.js';
export default class tab {
  constructor() {
    this.generalTabFunc();
  }

  generalTabFunc() {
    const $tabBlock = document.querySelectorAll('.js-tab');

    if ($tabBlock.length) {
      $tabBlock.forEach((blockElm, blockIdx) => {

        const $tabBtn = blockElm.querySelectorAll('.js-tabBtn'),
          $tabBtnParent = blockElm.querySelectorAll('.js-tabBtnWrap'),
          $tabItemParent = blockElm.querySelectorAll('.js-tabContWrap'),
          $tabItem = blockElm.querySelectorAll('.js-tabCont');

        $tabItemParent.forEach(contElm => {
          const $targetCont = contElm.querySelectorAll('.js-tabCont');
          for (let i = 0; i < $targetCont.length; i++) {
            $targetCont[i].setAttribute('id', `panel-${blockIdx}-${i}`);
          }
        });

        $tabBtnParent.forEach((parentElm, parentIndex) => {
          const $targetBtn = parentElm.querySelectorAll('.js-tabBtn');

          function removeClass(i) {
            $tabItemParent.forEach(contElm => {
              contElm.querySelectorAll('.js-tabCont')[i].classList.remove('is-active');
              contElm.querySelectorAll('.js-tabCont')[i].setAttribute('aria-hidden', `true`);
            });
            $targetBtn[i].classList.remove('is-active');
            $targetBtn[i].setAttribute('aria-selected', `false`);
            $targetBtn[i].setAttribute('tabindex', `-1`);
          }

          function addClass($index) {
            $tabItemParent.forEach(contElm => {
              const $activeCont = contElm.querySelectorAll('.js-tabCont')[$index];
              $activeCont.classList.add('is-active');
              $activeCont.setAttribute('aria-hidden', `false`);

              // タブ切替で表示された該当コンテンツ自体へフォーカスを移動
              //（位置調整は別途 scrollTo に任せるため preventScroll）。
              $activeCont.setAttribute('tabindex', '-1');
              $activeCont.focus({ preventScroll: true });
            });
            $targetBtn[$index].classList.add('is-active');
            $targetBtn[$index].setAttribute('aria-selected', `true`);
            $targetBtn[$index].setAttribute('tabindex', `0`);
          }

          function removeAnimationClass(contents) {
            if (contents.classList.contains('sai-animate')) {
              contents.classList.remove('sai-animate');
            }

            const $saiItemList = contents.querySelectorAll('.sai-init');
            $saiItemList.forEach(elm => {
              elm.classList.remove('sai-animate');
            });
          }

          // タブ切替で表示されたコンテンツ内のsai-init要素にsai-animateを付与
          // (removeAnimationClassで一度クリアした後にrAF経由で再適用することで
          // CSS transitionを再生させる)
          function addAnimationClass(contents) {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                if (contents.classList.contains('sai-init')) {
                  contents.classList.add('sai-animate');
                }
                contents.querySelectorAll('.sai-init').forEach(elm => {
                  elm.classList.add('sai-animate');
                });
              });
            });
          }

          function btnAction(currentIdx, currentParent) {
            removeAnimationClass($tabItem[currentIdx]);
            for (let i = 0, length = $targetBtn.length; i < length; i++) {
              removeClass(i);
            }
            addClass(currentIdx);
            addAnimationClass($tabItem[currentIdx]);

            const rect = blockElm.getBoundingClientRect(),
              scrollTop = window.pageYOffset || document.documentElement.scrollTop,
              elmTop = rect.top + scrollTop - document.getElementById('gHeader').clientHeight;

            if (currentParent !== 0) {
              // Lenis 稼働中は native の smooth scroll が毎フレーム上書きされて効かないため、
              // Lenis があれば Lenis 経由でスクロールする。
              if (window.__lenis && typeof window.__lenis.scrollTo === 'function') {
                window.__lenis.scrollTo(elmTop);
              } else {
                window.scrollTo({
                  top: elmTop,
                  behavior: 'smooth'
                });
              }
            }

            const $activeCont = blockElm.querySelectorAll('.js-tabCont.is-active'),
              $currentActive = [].slice.call($tabItemParent[0].querySelectorAll('.js-tabCont')).indexOf($activeCont[0]),
              $currentActiveCont = $activeCont[$activeCont.length - 1],
              $activeTarget = $currentActiveCont.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'),
              $currentActiveTarget = $activeTarget[$activeTarget.length - 1];

            // 表示コンテンツにフォーカス可能要素が無い場合は $currentActiveTarget が
            // undefined になるため、参照前にガードする。
            const oldListener = $currentActiveTarget && $currentActiveTarget._keydownListener;
            if ($currentActiveTarget && oldListener) {
              $currentActiveTarget.removeEventListener('keydown', oldListener);
            }

            const newListener = event => {
              if (event.key === 'Tab') {

                if ($currentActive !== $tabItemParent[0].querySelectorAll('.js-tabCont').length - 1) {
                  event.preventDefault();
                  btnAction($currentActive + 1, 0);
                }
              }
            };

            if ($currentActiveTarget) {
              $currentActiveTarget.addEventListener('keydown', newListener);
              $currentActiveTarget._keydownListener = newListener;
            }
          }

          $tabBtn.forEach((btnElm, btnIndex) => {
            const $targetParent = btnElm.closest('.js-tabBtnWrap'),
              $target = $targetParent.querySelectorAll('.js-tabBtn'),
              $parentIndex = [].slice.call($tabBtnParent).indexOf($targetParent),
              $btnIndex = [].slice.call($target).indexOf(btnElm);

            btnElm.setAttribute('aria-controls', `panel-${blockIdx}-${$btnIndex}`);

            btnElm.addEventListener('click', event => {
              event.preventDefault();
              btnAction($btnIndex, $parentIndex);
            });

            btnElm.addEventListener('keydown', event => {
              if (event.key === 'Enter' || event.key === ' ') {
                btnAction($btnIndex, $parentIndex);
              }

              if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
                event.preventDefault();
                let newIndex;

                if (event.key === 'ArrowRight') {
                  newIndex = $btnIndex + 1 >= $target.length ? 0 : $btnIndex + 1;
                } else {
                  newIndex = $btnIndex - 1 < 0 ? $target.length - 1 : $btnIndex - 1;
                }

                $target[newIndex].focus();
                btnAction(newIndex, $parentIndex);
              }
            });
          });

          const $activeCont = blockElm.querySelectorAll('.js-tabCont.is-active'),
            $currentActive = [].slice.call($tabItemParent[0].querySelectorAll('.js-tabCont')).indexOf($activeCont[0]),
            $currentActiveCont = $activeCont[$activeCont.length - 1],
            $activeTarget = $currentActiveCont.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'),
            $currentActiveTarget = $activeTarget[$activeTarget.length - 1];

          if (!$currentActiveTarget) return;
          $currentActiveTarget.addEventListener('keydown', event => {
            if (event.key === 'Tab') {
              event.preventDefault();
              btnAction($currentActive === 0 ? $currentActive + 1 : $tabItemParent[0].querySelectorAll('.js-tabCont').length - 1, 0);
            }
          });
        });
      });
    }
  }
}
